import { Button, ButtonProps } from "@mui/material";

function PageHeaderButton(props: ButtonProps) {
  const { children } = props;

  return (
    <Button variant="contained" disableElevation {...props}>
      {children}
    </Button>
  );
}

export default PageHeaderButton;
